var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 435.933 435.933",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M286.482,279.088c0.944,1.249,0.939,2.973-0.023,4.225l-65.723,85.483c-0.658,0.867-1.682,1.368-2.762,1.368 c-1.081,0-2.102-0.501-2.764-1.368l-65.727-85.483c-0.476-0.621-0.722-1.368-0.722-2.12c0-0.741,0.236-1.485,0.705-2.104 c0.941-1.253,2.607-1.724,4.069-1.137l43.516,17.176V194.393c0-1.926,1.556-3.48,3.486-3.48h34.877c1.92,0,3.485,1.554,3.485,3.48 v100.74l43.516-17.177C283.873,277.37,285.54,277.841,286.482,279.088z M196.93,65.927C-28.392,70.252-1.475,181.812,3.69,198.193 c5.532,27.833,26.852,41.76,48.488,33.864l41.166-12.881c22.179-8.096,36.25-38.272,31.408-67.418l-0.917-5.518 c74.849-21.183,139.407-15.746,189.768-1.727l-0.396,2.353c-4.819,29.149,9.231,59.333,31.423,67.423l41.164,17.16 c18.604,6.791,36.965-6.287,45.271-27.171c0.107,0.09,0.173,0.15,0.173,0.15s1.139-2.812,2.288-7.625 c0.093-0.375,0.163-0.786,0.262-1.155c0.191-0.881,0.383-1.792,0.575-2.785c0.115-0.561,0.246-1.092,0.353-1.658l-0.041-0.035 C440.692,155.657,434.471,61.393,196.93,65.927z",
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHang);
export default __webpack_public_path__ + "static/media/hang.3be7456577a0dc22c4bf9498b3edc38a.svg";
export { ForwardRef as ReactComponent };